import { useDispatch, useSelector } from "react-redux";

import { useQuoteService } from "@/services/quote.service";
import { planSelected as planSelectedAction } from "@/redux/actions/plans";
import { usePlansContext } from "../context/PlansContext";
import { CODE_VIDA_CT } from "@/utils/consts";

export const useQuote = ({ setShowModalError }) => {
  const planSelected = useSelector((state) => state.plans.planSelected);
  const userData = useSelector((state) => state.vida.userData);
  const currencyPlan = useSelector((state) => state.plans.currencyPlan);
  const dispatch = useDispatch();

  const { createQuoteVe } = useQuoteService();
  const { setLoadingQuote, setLoadingBanks } = usePlansContext();

  const getFrequenciesFromAmounts = (amounts = []) => {
    if (amounts.length === 0) return [];

		const frequenciesWithOrder = amounts.map(m => ({
			label: m.frecuenciaPago,
			order: m.orden,
		}))

		const orderedFrequencies = [...frequenciesWithOrder].sort(
			(a, b) => a.order - b.order
		)
		return orderedFrequencies.map(f => ({
			text: f.label,
			value: f.label,
			name: f.label,
		}))
	}

  const sendQuote = async ({
    sumAssured,
    savingTime,
    returnPercentage,
    frequency,
  }, callback) => {
    const reqSumAssured =
      sumAssured && /\d/.test(sumAssured.text)
        ? sumAssured.text.replace(/[^\d]/g, "")
        : String(sumAssured.value);
    const reqSavingTime = savingTime?.text.replace(/[^\d]/g, "");
    const reqReturnPercentage = returnPercentage?.text.replace(/[^\d]/g, "");

    const payload = {
      codigoProducto: CODE_VIDA_CT.PRODUCT,
      codigoAplicacion: CODE_VIDA_CT.APPLICATION,
      fechaNacimiento: userData.fechaNacimiento,
      sexo: userData.sexo,
      sumaAsegurada: reqSumAssured,
      anios: reqSavingTime,
      moneda: currencyPlan,
      porcentajeDevolucion: reqReturnPercentage,
      encriptado: true,
    };

    setLoadingQuote(true);
    try {
      const response = await createQuoteVe(payload);
      if (callback) callback(response);

      const frequencies = getFrequenciesFromAmounts(response?.montosPagar)
      const defaultFrequency = frequencies[0]?.value;
      const currentFrequency = frequency ?? defaultFrequency
      const currentPlanSelected = response;
      await dispatch(
        planSelectedAction({
          ...planSelected,
          ...currentPlanSelected,
          sumAssured,
          savingTime,
          returnPercentage,
          frequency: currentFrequency,
          frequencies
        })
      );
      if (!currentPlanSelected.idCotizacion) setShowModalError(true);

      return {
        frequencies,
        currentFrequency
      }
    } catch (error) {
      setShowModalError(true);
    } finally {
      setLoadingQuote(false);
      setLoadingBanks(false);
    }
  };

  return {
    sendQuote,
  };
};
